import { render, staticRenderFns } from "./ConfirmProductModal.vue?vue&type=template&id=983de522"
import script from "./ConfirmProductModal.vue?vue&type=script&lang=js"
export * from "./ConfirmProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports